var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLimitationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2379_48229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1515 4.18172L1.97495 19.5012C1.78575 19.8289 1.68564 20.2004 1.68458 20.5787C1.68352 20.9571 1.78155 21.3291 1.96891 21.6578C2.15627 21.9865 2.42643 22.2604 2.75252 22.4523C3.07861 22.6442 3.44926 22.7473 3.82759 22.7515H22.1807C22.559 22.7473 22.9296 22.6442 23.2557 22.4523C23.5818 22.2604 23.852 21.9865 24.0393 21.6578C24.2267 21.3291 24.3247 20.9571 24.3237 20.5787C24.3226 20.2004 24.2225 19.8289 24.0333 19.5012L14.8568 4.18172C14.6636 3.86332 14.3917 3.60006 14.0672 3.41736C13.7427 3.23465 13.3765 3.13867 13.0041 3.13867C12.6317 3.13867 12.2656 3.23465 11.9411 3.41736C11.6166 3.60006 11.3446 3.86332 11.1515 4.18172Z",
    stroke: "black",
    strokeWidth: 1.62513,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0039 9.75V14.0837",
    stroke: "black",
    strokeWidth: 1.62513,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0039 18.418H13.0172",
    stroke: "black",
    strokeWidth: 1.62513,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2379_48229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.002,
    height: 26.002,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimitationsIcon);
export default __webpack_public_path__ + "static/media/limitations-icon.81fff8d72e8505980a296e774e001eef.svg";
export { ForwardRef as ReactComponent };